function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 16A8 8 0 108 0a8 8 0 000 16zM9.25 4.25a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM7 9H6V7h3v6H7V9z",
  fill: "inherit"
});

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#fff"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0id2hpdGUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOCAxNkMxMi40MTgzIDE2IDE2IDEyLjQxODMgMTYgOEMxNiAzLjU4MTcyIDEyLjQxODMgMCA4IDBDMy41ODE3MiAwIDAgMy41ODE3MiAwIDhDMCAxMi40MTgzIDMuNTgxNzIgMTYgOCAxNlpNOS4yNSA0LjI1QzkuMjUgNC45NDAzNiA4LjY5MDM2IDUuNSA4IDUuNUM3LjMwOTY0IDUuNSA2Ljc1IDQuOTQwMzYgNi43NSA0LjI1QzYuNzUgMy41NTk2NCA3LjMwOTY0IDMgOCAzQzguNjkwMzYgMyA5LjI1IDMuNTU5NjQgOS4yNSA0LjI1Wk03IDlINlY3SDhIOVY4VjEzSDdWOVoiIGZpbGw9ImluaGVyaXQiLz4KPC9zdmc+Cg==";
export { SvgInfo as ReactComponent };